import { collections } from '@/mocks/homeData';

export default function CollectionGrid() {
  return (
    <section id="collection" className="w-full border-y border-background-200 bg-background-100/60">
      <div className="px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-primary-600">
              <i className="ri-bookmark-3-line text-sm"></i>
              COLLECTION INDEX
            </p>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              合集索引
            </h2>
            <p className="mt-3 max-w-2xl font-label text-sm leading-relaxed text-foreground-600">
              把零散的爆料按题材归拢成合集，同一件事的多个版本、后续更新都收在同一条索引里，翻起来不用来回找。
            </p>
          </div>
          <span className="font-label text-sm text-foreground-500">
            共 {collections.length} 个合集 · 持续收集中
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item) => (
            <a
              key={item.id}
              href="#collection"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 cursor-pointer"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="rounded-full bg-background-100 px-2.5 py-1 font-label text-xs text-foreground-600">
                  {item.count}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 font-label text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
                  <i className="ri-refresh-line text-sm"></i>
                  {item.updated}
                </span>
                <span className="flex items-center gap-1 font-label text-xs text-primary-700">
                  查看合集
                  <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}